<template>
    <v-select
        :options="searchedLocations"
        class="provider-search"
        placeholder="Location name or specialty"
        :value="value"
        @search="search"
        @input="emitLocation"
    >
        <template slot="no-options">
            Type to search locations
        </template>
        <template #option="option">
            <div class="flex">
                <div class="image" :style="`background-image: url(${option.avatar})`"></div>
                <div class="text">
                    <strong>{{ option.building_name }}</strong>
                </div>
            </div>
        </template>
    </v-select>
</template>

<script>
import {mapState} from 'vuex';
import VSelect from 'vue-select';

export default {
    components: {VSelect},

    data() {
        return {
            value: null,
        };
    },

    computed: {
        ...mapState(['searchedLocations']),
    },

    methods: {
        search(search) {
            this.$store.dispatch('getSearchedLocations', search);
        },

        emitLocation(location) {
            this.value = location;
            this.$emit('input', location ? location.id : null);
            this.value = null;
        },
    },
};
</script>
